import { routeDefinitions, type RouteRecordRaw } from '@gat-ship/lib/router'
export function createSupportRoutes(
  startPath: string
): readonly RouteRecordRaw[] {
  return [
    {
      path: startPath,
      component: () => import('../views/support-layout.vue'),
      children: [
        {
          path: '',
          name: routeDefinitions.support.list,
          component: () => import('../views/support-view.vue')
        },
        {
          path: 'sessions',
          name: routeDefinitions.support.sessions,
          component: () => import('../views/support-sessions-view.vue')
        },
        {
          path: 'history',
          name: routeDefinitions.support.history,
          component: () => import('../views/support-sessions-history-view.vue')
        }
      ]
    }
  ]
}
